import * as React from "react";
import { FeedItemNewForumTopic } from "../../../server/feed/buildfeed";
import {
  FeedElementContainer,
  ActionPanel,
} from "../DesignSystem/formatting/FeedComponents";
import { LinkToUser } from "../DesignSystem/LinkToUser";
import { RLink } from "../DesignSystem/RLink";
import { FormattedText } from "../DesignSystem/FormattedText";
import { DateWithTooltip } from "../DesignSystem/DateWithTooltip";

export const FeedElementNewForumTopic = ({
  item,
}: {
  item: FeedItemNewForumTopic;
}) => {
  const { created, topic, user } = item;
  const content = topic.body;

  return (
    <FeedElementContainer
      href={`/forum/topic/${topic.id}`}
      avatars={[user]}
      icon={"new"}
      title={
        <>
          <LinkToUser linkUser={user} />
          <span className="text-slate-500 dark:text-slate-400">
            {" "}
            posted a new forum topic:{" "}
          </span>
          <RLink white to={"/forum/topic/" + topic.id}>
            {topic.title}
          </RLink>
          .
        </>
      }
      subtitle={<DateWithTooltip date={new Date(created)} />}
      bottom={<ActionPanel seePost={{ url: `/forum/topic/${topic.id}` }} />}
    >
      <FormattedText text={content} maxLength={1000} />
    </FeedElementContainer>
  );
};
